export default function PHP_ob_end_clean() {
  return (
    <div>
      <h1>PHP_ob_end_clean</h1>
    </div>
  );
}
